export default __webpack_public_path__ + "static/media/logo-transitar-gray50.9cc02590.png";